import { render, staticRenderFns } from "./supervise-staff-table.vue?vue&type=template&id=c420f1f2&"
import script from "./supervise-staff-table.vue?vue&type=script&lang=js&"
export * from "./supervise-staff-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "supervise-staff-table.vue"
export default component.exports